module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAAMRJREFUKFOVkaFOwnEUhb8vG9Skz+BmdFAoRgJvQHZTKRSewMADOJtZGjSabASKs8F8AJMUq4Xjfmw4/e9P8Ja73fudc7Z75R9llU1yBxyr19XdHzjJAbAESm+pb78FVXgInAJz4BZoqF87wQ+c5Ax4Bs7VjyRPwFrt1cEzYKQ+lGWSQ+AV6KuTMts6J+kCxaGpbnZOSRrAGLhQ301yBKyAjvpSc50B0AYuC3y/jdCbupMnKelTYFHgPvCofu77T5IT4OobvoZHAy0tvjYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Previous.png
// module id = KSZE
// module chunks = 26